<div class="center">
<nz-avatar *ngIf="!_cpS.isInvestmentHisoryLoading && currentInvestor?.parentProfileImageUrl" nzIcon="user" [ngClass]="!_cpS.isInvestmentHisoryLoading && currentInvestor?.parentProfileImageUrl ? 'supplierLogo' : ''"
            [nzSrc]="currentInvestor.parentProfileImageUrl" [nzShape]="'square'"  style="width: 250px !important;height: auto;" >
        </nz-avatar>
      </div>
<h3 class="center company-name-text" *ngIf="!_cpS.isInvestmentHisoryLoading && !currentInvestor?.parentProfileImageUrl">{{_cpS.isInvestmentHisoryLoading ? 'Investor' : currentInvestor?.companyName}}
</h3>
<div class="center investment-history-text">Investment History</div>
<div class="d-flex approve-invoice" [ngClass]="_cpS.isInvestmentHisoryLoading && !currentInvestor ? 'align-i-c' : ''">
  <h3 *ngIf="!isFromInvestmentsList && !currentInvestor" class="block-text">Select Investor to See History /
    Details</h3>
  <div class="center w-100" *ngIf="currentInvestor">
    <div>
    <div class="last-year-text">
      {{currentYear}}
    </div>
    <nz-skeleton class="p-1" *ngIf="_cpS.isInvestmentHisoryLoading" [nzParagraph]="{ rows: 2}" [nzActive]="true"></nz-skeleton>
    <nz-table [nzOuterBordered]="true" [nzShowPagination]="false" [nzData]="currentYearApiInvestorsData" #apiDataTable
      *ngIf="!_cpS.isInvestmentHisoryLoading" nzTableLayout="fixed">
      <tbody>
        <tr *ngFor="let data of apiDataTable.data">
          <td>{{ data.ScheduleDate.toString().slice(0,-1) | date: 'MMM dd' }}</td>
          <td nzEllipsis [nzTooltipTitle]="getStatus(data).length > 5 ? getStatus(data) : ''"
            nzTooltipPlacement="bottomLeft" nz-tooltip=""> {{ getStatus(data) }}</td>
          <td>{{ data.QBOEntityNo ? data.QBOEntityNo : '-' }}</td>
          <td>${{data.Amount | number: '1.2-2'}}</td>
        </tr>
        <tr *ngIf="currentYearApiInvestorsData.length > 0">
          <td colspan="4" [nzAlign]="'center'"><a (click)="navigateToActivity(currentYear)">View more ></a></td>
        </tr>
      </tbody>
    </nz-table>
  </div>
    <div>
    <div class="last-year-text">
      {{lastYear}}
    </div>
    <nz-skeleton *ngIf="_cpS.isInvestmentHisoryLoading " [nzParagraph]="{ rows: 2}" [nzActive]="true"></nz-skeleton>
    <nz-table [nzOuterBordered]="true" [nzShowPagination]="false" [nzData]="lastYearApiInvestorsData" #apiUsersDataTable
      *ngIf="!_cpS.isInvestmentHisoryLoading" nzTableLayout="fixed">
      <tbody>
        <tr *ngFor="let data of apiUsersDataTable.data">
          <td>{{ data.ScheduleDate.toString().slice(0,-1) | date: 'MMM dd' }}</td>
          <td nzEllipsis [nzTooltipTitle]="getStatus(data).length > 5 ? getStatus(data) : ''"
            nzTooltipPlacement="bottomLeft" nz-tooltip=""> {{ getStatus(data) }}</td>
          <td>{{ data.QBOEntityNo ? data.QBOEntityNo : '-' }}</td>
          <td> $ {{data.Amount | number: '1.2-2'}}</td>
        </tr>
        <tr *ngIf="lastYearApiInvestorsData.length > 0">
          <td colspan="4" [nzAlign]="'center'"><a (click)="navigateToActivity(lastYear)">View more ></a></td>
        </tr>
      </tbody>
    </nz-table>
  </div>
    <div class="client-profile-box">
      <nz-avatar *ngIf="!_cpS.isInvestmentHisoryLoading" [nzSize]="120" [ngClass]="currentInvestor?.profileImageUrl ? 'mt-60' : 'client-profile'" nzIcon="user"
        [nzSrc]="currentInvestor?.profileImageUrl && !_cpS.isInvestmentHisoryLoading ? currentInvestor?.profileImageUrl : ''">
      </nz-avatar>
      <nz-skeleton *ngIf="_cpS.isInvestmentHisoryLoading" [nzParagraph]="{ rows: 3}" [nzActive]="true"></nz-skeleton>
      <div *ngIf="!_cpS.isInvestmentHisoryLoading && currentInvestor">
        <p class="current-investor-name"> {{currentInvestor.investorDisplayName}}</p>
        <p class="company-name">{{currentInvestor.title}}</p>
        <p class="company-name">{{currentInvestor.location ? currentInvestor.location : '' }}</p>
        <div class="d-flex justify-content-c mb-1" *ngIf="currentInvestor.mobileNumber">
          <span class="mobile-number-text">Mobile:</span>
          <a class="mobile-number-text" [href]="'tel:'+currentInvestor.mobileNumber"
            target="_blank">{{currentInvestor.mobileNumber | mask : '(000) 000-0000'}}</a>
        </div>
        <div class="d-flex justify-content-c mb-1" *ngIf="currentInvestor.phoneNumber">
          <span class="mobile-number-text">Office:</span>
          <a class="mobile-number-text" [href]="'tel:'+currentInvestor.phoneNumber"
            target="_blank">{{currentInvestor.phoneNumber | mask : '(000) 000-0000'}}</a>
        </div>
        <div class="d-flex justify-content-c">
          <div nz-row>
            <div nz-col [nzSpan]="5" class="d-flex justify-content-end">
              <span class="mobile-number-text">Email:</span>
            </div>
            <div nz-col [nzSpan]="19" class="left">
              <span *ngIf="multipleEmails.length == 0">-</span>
              <div *ngFor="let email of multipleEmails">
                <a class="mobile-number-text d-flex" style="width: max-content;" [href]="'mailto:'+email"
                  target="_blank">{{email}}</a>
                </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-i-c justify-content-c">
          <a class="social icon" *ngIf="currentInvestor.linkedInProfileUrl" [href]="currentInvestor.linkedInProfileUrl"
            target="_blank"><span nz-icon nzType="linkedin" nzTheme="outline"></span></a>
          <a class="social icon" [href]="'mailto:'+currentInvestor.email" target="_blank"><span nz-icon nzType="mail"
              nzTheme="outline"></span></a>
        </div>
      </div>
    </div>
  </div>
</div>